import Player from "@vimeo/player";

class PdpHighlightsCarousel extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.isMobile = window.matchMedia("(max-width: 767px)");
    this.carousel = this.querySelector("[data-video-carousel]");
    this.nav = this.querySelector("[data-video-carousel-nav]");
    this.swiper = null;
    this.currentSlide = -1;
    this.slideDelayTimeout = null;
    this.players = new Map();
    this.mediaControls = this.querySelectorAll("[data-media-controls]");

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", (event) => {
        window.loadSwiper.then((swiperLib) => {
          this.swiperLib = swiperLib;
          this.initFunction();
        });
      });
    }

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;
      this.initFunction();
    });

    this.hasInteracted = false;

    this.addEventListener("click", (e) => {
      const slide = e.target.closest(".swiper-slide");
      if (!slide) return;
      this.hasInteracted = true;
      const { slideIndex } = slide.dataset;

      this.handleSlide(null, parseInt(slideIndex, 10));
    });

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.handleSlide("next");
          observer.unobserve(this);
          observer.disconnect();
        }
      },
      {
        rootMargin: "0px 0px -50% 0px",
      },
    );

    observer.observe(this);

    const slideObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) =>
          entry.target.classList.toggle(
            "pdp-highlights-carousel__slide--visible",
            entry.isIntersecting,
          ),
        );
      },
      {
        root: this.querySelector(".pdp-highlights-carousel"),
        rootMargin: "0px 100% 0px 0px",
        // threshold: 0.25,
        threshold: [0.9],
      },
    );

    this.querySelectorAll(".swiper-slide").forEach((slide) => {
      slideObserver.observe(slide);
    });
  }

  slideTo(index, cb, force) {
    if (!this.swiper || (this.hasInteracted && !force)) return;

    const slide = () => {
      this.ignoreChangeEvent = true;
      this.swiper.slideTo(index);
      cb();
    };

    if (this.isMobile.matches) {
      this.slideDelayTimeout = setTimeout(() => {
        slide();
      }, 1000);
    } else {
      slide();
    }
  }

  handleSlide(direction, targetIndex) {
    const allSlides = this.swiper.slides;
    const lastSlide = allSlides.length - 1;

    let previousIndex = this.currentSlide;
    this.currentSlide = isFinite(targetIndex)
      ? targetIndex
      : direction === "prev"
        ? this.currentSlide - 1
        : this.currentSlide + 1;
    this.currentSlide = this.currentSlide > lastSlide ? 0 : this.currentSlide;
    this.currentSlide = this.currentSlide < 0 ? lastSlide : this.currentSlide;

    let currentIndex = this.currentSlide;
    let slideTo = currentIndex == lastSlide ? 0 : currentIndex + 1;
    currentIndex = currentIndex < 0 ? 0 : currentIndex;
    const activeSlide = allSlides[currentIndex];
    const previousSlide = allSlides[previousIndex];

    if (previousSlide?.classList.contains("vimeo")) {
      const mediaWrapper = previousSlide.querySelector(
        ".pdp-highlights-carousel__media",
      );
      mediaWrapper.classList.remove("media-is-playing--true");
      mediaWrapper.classList.add("media-is-playing--false");
      const iframe = previousSlide.querySelector("iframe");
      const player = this.players.get(iframe);
      player?.pause();
    }

    if (previousSlide?.classList.contains("cdn")) {
      const mediaWrapper = previousSlide.querySelector(
        ".pdp-highlights-carousel__media",
      );
      mediaWrapper.classList.remove("media-is-playing--true");
      mediaWrapper.classList.add("media-is-playing--false");
      const slideVideo = previousSlide.querySelector("video");
      slideVideo.pause();
    }

    if (activeSlide.classList.contains("slide__image")) {
      // const imageChange = setTimeout(() => {
      //   this.slideTo(slideTo, () => this.handleSlide("next"));
      // }, 2000);
      // this.swiper.on("sliderMove", () => {
      //   clearTimeout(imageChange);
      // });
    } else {
      if (activeSlide.classList.contains("vimeo")) {
        const iframe = activeSlide.querySelector("iframe");
        const player = this.players.get(iframe) || new Player(iframe);
        const mediaWrapper = activeSlide.querySelector(
          ".pdp-highlights-carousel__media",
        );

        const mediaControls = activeSlide.querySelector(
          "[data-media-controls]",
        );

        const toggleMediaControls = (e) => {
          e.stopImmediatePropagation();

          if (slideVideo.paused) {
            player.play();
            mediaWrapper.dataset.playing = "true";
          } else {
            player.pause();
            mediaWrapper.dataset.playing = "false";
          }
        };

        mediaControls.removeEventListener("click", toggleMediaControls);
        mediaControls.addEventListener("click", toggleMediaControls);

        // player.off("ended");
        // player.on("ended", () => {
        //   this.slideTo(slideTo, () => this.handleSlide("next"));
        // });

        if (mediaWrapper.classList.contains("media-is-autoplay--true")) {
          if (!this.players.has(iframe)) {
            this.players.set(iframe, player);

            player.play();

            mediaWrapper.dataset.playing = "true";
          }
        }
      } else {
        const slideVideo = activeSlide.querySelector("video");
        const mediaWrapper = activeSlide.querySelector(
          ".pdp-highlights-carousel__media",
        );

        const mediaControls = activeSlide.querySelector(
          "[data-media-controls]",
        );

        const toggleMediaControls = (e) => {
          e.stopImmediatePropagation();

          if (slideVideo.paused) {
            slideVideo.play();
            mediaWrapper.dataset.playing = "true";
          } else {
            slideVideo.pause();
            mediaWrapper.dataset.playing = "false";
          }
        };

        mediaControls.removeEventListener("click", toggleMediaControls);
        mediaControls.addEventListener("click", toggleMediaControls);

        // const onEnded = (e) => {
        //   e.stopImmediatePropagation();
        //   this.slideTo(slideTo, () => this.handleSlide("next"));
        // };
        // slideVideo.removeEventListener("ended", onEnded);
        // slideVideo.addEventListener("ended", onEnded);

        if (mediaWrapper.classList.contains("media-is-autoplay--true")) {
          slideVideo.play();
          mediaWrapper.dataset.playing = "true";
        }
      }
    }
  }

  initFunction() {
    if (!this.carousel) return;

    const { Swiper } = this.swiperLib;

    const params = {
      speed: 600,
      slidesPerView: 1,
      spaceBetween: 24,
      touchEventsTarget: "wrapper",
      direction: "horizontal",
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        // 1600: {
        //   slidesPerView: "auto",
        //   spaceBetween: 20,
        //   allowTouchMove: false,
        // },
      },
    };

    const userArrows = this.querySelectorAll(".swiper-arrow");
    userArrows.forEach((arrow) => {
      arrow.addEventListener("click", () => {
        let cap = this.swiper.slides.length;
        if (arrow.classList.contains("swiper-arrow-next")) {
          const nextSlideIndex =
            this.currentSlide + 1 >= cap ? 0 : this.currentSlide + 1;
          this.slideTo(nextSlideIndex, () => this.handleSlide("next"), true);
        } else {
          const nextSlideIndex =
            this.currentSlide <= 0 ? cap - 1 : this.currentSlide - 1;
          this.slideTo(nextSlideIndex, () => this.handleSlide("prev"), true);
        }
      });
    });

    this.swiper = new Swiper(this.carousel, params);

    this.swiper.on("slideChange", () => {
      // For some reason `swiper.slideTo(a, b, false) is still
      // firing this change event, so we have to manually ignore
      // changes triggered by the auto-advancing. We only want to
      // act on slideChange events caused by swiping/user input.
      clearTimeout(this.slideDelayTimeout);

      if (this.ignoreChangeEvent) {
        this.ignoreChangeEvent = false;
        return;
      }

      if (!this.hasInteracted || this.isMobile.matches) {
        this.handleSlide(this.swiper.swipeDirection);
      }
    });

    this.swiper.on("lock", () => {
      this.nav.style.display = "none";
    });
    this.swiper.on("unlock", () => {
      this.nav.style.display = null;
    });

    this.nav.style.display = this.swiper.isLocked ? "none" : null;

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", (event) => {
        this.swiper.destroy();
      });
    }
  }
}

if (!customElements.get("pdp-highlights-carousel")) {
  customElements.define("pdp-highlights-carousel", PdpHighlightsCarousel);
}
